exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".fallback{width:100%;height:300px;-webkit-filter:blur(20px);filter:blur(20px)}.lazy-container{-webkit-transition:all .3s ease;-o-transition:all ease .3s;transition:all .3s ease}", "", {"version":3,"sources":["/Users/sourabhkumarbanka/dev/alienbrains_main_website/src/Components/LazyComponent/style.css"],"names":[],"mappings":"AAAA,UACE,WAAY,AACZ,aAAc,AACd,0BAA2B,AACnB,iBAAmB,CAC5B,AAED,gBACE,gCAAkC,AAClC,2BAA6B,AAC7B,uBAA0B,CAC3B","file":"style.css","sourcesContent":[".fallback {\n  width: 100%;\n  height: 300px;\n  -webkit-filter: blur(20px);\n          filter: blur(20px);\n}\n\n.lazy-container {\n  -webkit-transition: all ease 0.3s;\n  -o-transition: all ease 0.3s;\n  transition: all ease 0.3s;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/Components/LazyComponent/style.css
// module id = 296
// module chunks = 0 2 4 5 6 7 8